let memoizedColumns = []
const GroupConfigurationColumn = () => {
    if (memoizedColumns.length > 0) {
        return memoizedColumns
    }
    memoizedColumns = [
        {
            accessorKey: 'checkbox',
            header: '',
        },
        {
            accessorKey: 'group_name',
            header: 'Group Name',
        }
    ]
    return memoizedColumns
}
export default GroupConfigurationColumn